import React, { ReactElement, ReactNode } from 'react';
import {
  Button, Table, Tbody, Td, Th, Tr,
} from 'idsk-react-components';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import FilledTableDates2 from './FilledTableDates2';
import FilledTableRelatedData3 from './FilledTableRelatedData3';
import FilledAttachments4 from './FilledAttachments4';
import './checkDataTable.scss';
import { useUserContext } from '../../../context/UserContext';
import UserRole from '../../../model/currentuser/UserRole';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  isUpdate?: boolean;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const CheckDataTable = ({
  prispevokVestnika,
  isUpdate = false,
  onChange,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();
  const renderFilledData = (): ReactNode => {
    if (isUpdate) {
      return (
        <FilledTableRelatedData3
          prispevokVestnika={prispevokVestnika}
          onChange={onChange}
        />
      );
    }
    switch (prispevokVestnika.activeStep) {
      case PrispevokVestnikaStepEnum.RELATED_DATA_3:
        return (
          <FilledTableDates2
            prispevokVestnika={prispevokVestnika}
            onChange={onChange}
          />
        );
      case PrispevokVestnikaStepEnum.ATTACHMENTS_4:
      case PrispevokVestnikaStepEnum.CHECK_DATA_6:
      case PrispevokVestnikaStepEnum.MAIN_ATTACHMENT_5:
        return (
          <FilledTableRelatedData3
            prispevokVestnika={prispevokVestnika}
            onChange={onChange}
          />
        );
      default:
        return (
          <></>
        );
    }
  };

  const canChangeAutor = (): boolean => pouzivatel?.roles.includes(UserRole.REZORTNE_ZBIERKY_SPRAVCA) && !isUpdate;

  return (
    <div className="check-data-table">
      <Table>
        <Tbody>
          <Tr>
            <Th width="30%">Autor príspevku</Th>
            <Td width="60%">{prispevokVestnika.vestnik.skratenyNazov}</Td>
            <Td width="10%">
              {canChangeAutor() && (
                <Button
                  className="autor-change-button"
                  size="small"
                  buttonStyle="link"
                  onClick={() => {
                    onChange(PrispevokVestnikaStepEnum.BASIC_DATA_1);
                  }}
                >
                  Zmeniť
                </Button>
              )}
            </Td>
          </Tr>
          <Tr>
            <Th width="30%">Vestník</Th>
            <Td width="60%">{prispevokVestnika.vestnik.nazov}</Td>
            <Td width="10%">
              {canChangeAutor() && (
                <Button
                  size="small"
                  buttonStyle="link"
                  onClick={() => {
                    onChange(PrispevokVestnikaStepEnum.BASIC_DATA_1);
                  }}
                >
                  Zmeniť
                </Button>
              )}
            </Td>
          </Tr>
          <Tr>
            <Th width="30%">Názov príspevku</Th>
            <Td width="60%">{prispevokVestnika.nazov}</Td>
            <Td width="10%">
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChange(PrispevokVestnikaStepEnum.BASIC_DATA_1);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
          <Tr>
            <Th>
              Krátky názov príspevku <span className="idsk-hint optional-message">(nepovinný údaj)</span>
            </Th>
            <Td width="60%">{prispevokVestnika.kratkyNazov}</Td>
            <Td width="10%">
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChange(PrispevokVestnikaStepEnum.BASIC_DATA_1);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
          <Tr>
            <Th>Číslo príspevku</Th>
            <Td width="60%">{prispevokVestnika.cislo}</Td>
            <Td width="10%">
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChange(PrispevokVestnikaStepEnum.BASIC_DATA_1);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
          {renderFilledData()}
        </Tbody>
      </Table>
      {(prispevokVestnika.activeStep === PrispevokVestnikaStepEnum.CHECK_DATA_6
      || isUpdate) && (
        <FilledAttachments4 prispevokVestnika={prispevokVestnika} onChange={onChange} />
      )}
    </div>
  );
};
export default CheckDataTable;
